module.exports = __webpack_public_path__ + "static/media/fb-gray.6c9d0875.svg";